var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"sim-hover primary--text"},[_vm._v("\n    "+_vm._s(_vm.item.who)+"\n  ")]),_vm._v("\n  login from\n  "),(_vm.item.details.fromAdmin)?_c('span',[_vm._v("admin")]):_c('span',[_vm._v("dashboard")])])
}
var staticRenderFns = []

export { render, staticRenderFns }